module.exports = __webpack_public_path__ + "static/media/bubble-quote.f16639bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/bubble-quote.svg
// module id = 2483
// module chunks = 7